// 分页每页条数读取助手：从后端全局配置读取，未配置时回退默认 50。
// 所有后台分页页面的 pageSize 都应通过这里获取，不在前端写死。
import { parttimeApi } from '../api/parttime';

const cache = {};
const DEFAULT_PAGE_SIZE = 50;

/**
 * 获取某页面的分页每页条数（page_size_H1/H2/H3/H5）
 * @param {string} key 全局配置 key
 * @returns {Promise<number>} 每页条数
 */
export async function getPageSize(key, def = DEFAULT_PAGE_SIZE) {
  if (cache[key]) return cache[key];
  try {
    const m = await parttimeApi.getConfig([key]);
    const n = parseInt(m && m[key], 10);
    cache[key] = (!Number.isNaN(n) && n > 0) ? n : def;
  } catch (e) {
    cache[key] = def;
  }
  return cache[key];
}